export * as dom from './dom';